import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { apiFetch, v1Path } from '../../lib/api';
import { isProjectId, projectWorkPath, setLastProjectId } from '../../lib/project-path';
import type { ProjectDto } from '../../lib/work-types';
import { useOverlays } from './overlay-context';

export default function CreateProjectModal() {
  const { createProjectOpen, setCreateProjectOpen, toast } = useOverlays();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit() {
    const n = name.trim();
    const ident = identifier.trim();
    if (!n || !ident) return;
    setBusy(true);
    try {
      const project = await apiFetch<ProjectDto>(v1Path('/projects'), {
        method: 'POST',
        body: JSON.stringify({ name: n, identifier: ident }),
      });
      if (!isProjectId(project.id)) {
        throw new Error('Create stream did not return a valid id.');
      }
      setLastProjectId(project.id);
      setCreateProjectOpen(false);
      setName('');
      setIdentifier('');
      navigate(projectWorkPath(project.id));
    } catch (err) {
      toast(err instanceof Error ? err.message : 'Failed to create stream');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={createProjectOpen} onOpenChange={setCreateProjectOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create stream</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label htmlFor="proj-name">Name</Label>
            <Input id="proj-name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-1">
            <Label htmlFor="proj-id">Identifier</Label>
            <Input
              id="proj-id"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value.toUpperCase())}
              placeholder="ENG"
              maxLength={12}
            />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => setCreateProjectOpen(false)}>
            Cancel
          </Button>
          <Button type="button" disabled={busy || !name.trim() || !identifier.trim()} onClick={() => void submit()}>
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
